/* eslint-disable react/prop-types */
import { useState } from "react";
import { Send } from "lucide-react";
import VoiceTextarea from "../../../components/VoiceTextarea";
import api from "../../../lib/api";

/**
 * TicketNotesSection — Phase 7 Sub-iter 7A.
 *
 * Comments thread on a ticket.  Reads `notes[]` from the ticket doc;
 * writes through `POST /tickets/{id}/notes`.  Trust Contract Rule 2:
 * inline add — no modal.
 */
export default function TicketNotesSection({ t, onReload }) {
  const [draft, setDraft] = useState("");
  const [saving, setSaving] = useState(false);

  const addNote = async () => {
    if (!draft.trim()) return;
    setSaving(true);
    try {
      await api.post(`/tickets/${t.id}/notes`, { text: draft });
      setDraft("");
      onReload();
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="hv-card p-5" data-testid="ticket-notes-section">
      <h3 className="font-display text-xl font-bold mb-3">Comments</h3>

      <div className="space-y-3 mb-4">
        {(t.notes || []).length === 0 && (
          <div className="text-sm text-[#a0aabf]">No comments yet — start the thread below.</div>
        )}
        {(t.notes || []).map((n) => (
          <div
            key={n.id}
            className="border border-white/5 rounded-md p-3 bg-white/[0.02]"
            data-testid={`ticket-note-${n.id}`}
          >
            <div className="text-xs text-[#647087]">
              <span className="text-[#1fb6c1]">{n.by_user_name}</span>
              {" · "}
              {new Date(n.created_at).toLocaleString("en-GB")}
            </div>
            <div className="text-sm mt-1.5 whitespace-pre-wrap">{n.text}</div>
          </div>
        ))}
      </div>

      <div className="flex gap-2 items-end">
        <div className="flex-1">
          <VoiceTextarea
            value={draft}
            onChange={setDraft}
            placeholder="Add a comment… or tap the mic to dictate."
            rows={3}
            context="lead_activity"
            testIdPrefix="ticket-note-voice"
            data-testid="ticket-note-input"
          />
        </div>
        <button
          onClick={addNote}
          disabled={saving || !draft.trim()}
          className="hv-btn hv-btn-primary"
          data-testid="ticket-note-add"
        >
          <Send className="w-4 h-4" /> Add
        </button>
      </div>
    </div>
  );
}
